import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import qs from 'qs';

import api from 'core/api';

const useAntecipationStore = create()(devtools(
  (get, set) => ({
    outdatedPositions: false,
    setOutdatedPositions: (value) => {
      set(state => ({
        ...state,
        outdatedPositions: value,
      }));
    },
    anticipate: ({
      operationId,
      quantity,
      comissionFeePercentage,
      sellAsset,
    }) => api.post('/unwinding', { operationId, quantity, comissionFeePercentage, sellAsset }),
    getReport: ({
      Filters,
    }) => api.get(`/unwinding/report?${qs.stringify({ Filters })}`, { responseType: 'arraybuffer' }),
  }),
));

export default useAntecipationStore;
